import { SOURCE } from "@/modules/campos_novos/settings";
import common, { simulator as simulatorApi } from "@/modules/common/api";
import http from "@/utils/http";

export default {
    reservoir: {
        getReservoirInfos(startDate, endDate): Promise<any> {
            return common.getReservoirInfos(SOURCE, startDate, endDate);
        }
    },
    simulator: {
        getData(): Promise<any> {
            return http.get("/api/campos-novos/simulator/detail/");
        },
        postData(data): Promise<any> {
            return http.post("/api/campos-novos/simulator/update/", data);
        },
        simulate(): Promise<any> {
            return simulatorApi.start(SOURCE);
        },
        stopSimulation(): Promise<any> {
            return simulatorApi.stop(SOURCE);
        },
        getStatus(): Promise<any> {
            return simulatorApi.getStatus(SOURCE);
        }
    }
};
